import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

interface G2ReviewContextValue {
  iframeUrl: string | null;
  openG2ReviewModal: (url: string) => void;
  closeG2ReviewModal: () => void;
}

const G2ReviewContext = createContext<G2ReviewContextValue | null>(null);

export const G2ReviewContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);

  const closeG2ReviewModal = useCallback(() => setIframeUrl(null), []);

  const value = useMemo(
    () => ({
      iframeUrl,
      openG2ReviewModal: setIframeUrl,
      closeG2ReviewModal,
    }),
    [iframeUrl, closeG2ReviewModal],
  );

  return (
    <G2ReviewContext.Provider value={value}>
      {children}
    </G2ReviewContext.Provider>
  );
};

export function useG2ReviewContext() {
  const ctx = useContext(G2ReviewContext);
  if (!ctx)
    throw new Error(
      'useG2ReviewContext must be used within G2ReviewContextProvider',
    );
  return ctx;
}
